import axios from 'axios';

class AuthService {
	async login(user) {
		let response = await axios.post('/WSLogin', {
			UsuarioEmail: user.email,
			UsuarioPassword: user.password
		});

		if (response.data.ErrorCod !== 0) {
			localStorage.removeItem('user');
			localStorage.removeItem('or_ac');

			const error = response.data.ErrorDsc;
			return {
				IsOk: false,
				Error: error,
				Usuario: null,
				OrganizadorActivo: null
			}
		}

		if (response.data.Usuario.AccessToken) {
			localStorage.setItem('user', JSON.stringify(response.data.Usuario));
		}

		let or_ac = null;
		if(response.data.Usuario.Organizaciones.length > 0){
			localStorage.setItem('or_ac', Number(response.data.Usuario.Organizaciones[0].OrganizadorId));
			or_ac = Number(response.data.Usuario.Organizaciones[0].OrganizadorId)
		}

		return {
			IsOk: true,
			Error: null,
			Usuario: response.data.Usuario,
			OrganizadorActivo: or_ac
		}

		//.then(this.handleResponseLogin)
		// .then(response => {
		// 	if (response.data.Usuario.AccessToken) {
		// 		localStorage.setItem('user', JSON.stringify(response.data.Usuario));
		// 	}

		// 	if(response.data.Usuario.Organizaciones.length > 0){
		// 		localStorage.setItem('or_ac', Number(response.data.Usuario.Organizaciones[0].OrganizadorId));
		// 	}

		// 	return response.data.Usuario;
		// });
	}

	logout() {
		localStorage.removeItem('user');
		localStorage.removeItem('or_ac');
	}

	register(user) {
		return axios.post('/WSRegistro', {
			username: user.username,
			email: user.email,
			password: user.password
		});
	}

	// handleResponseLogin(response) {
	// 	if (response.data.ErrorCod !== 0) {
	// 		localStorage.removeItem('user');
	// 		localStorage.removeItem('or_ac');
	// 		// location.reload(true);

	// 		const error = response.data.ErrorDsc;
	// 		return Promise.reject(error);
	// 	}

	// 	return Promise.resolve(response);
	// }
}

export default new AuthService();